export default [
  { name: 'Eastern Cape', code: 'EC' },
  { name: 'Free State', code: 'FS' },
  { name: 'Gauteng', code: 'GT' },
  { name: 'KwaZulu-Natal', code: 'NL' },
  { name: 'Limpopo', code: 'LP' },
  { name: 'Mpumalanga', code: 'MP' },
  { name: 'North West', code: 'NW' },
  { name: 'Northern Cape', code: 'NC' },
  { name: 'Western Cape', code: 'WC' }
];
